import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "ohmic-string-selection" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("label", { class: "form-label" }, "Select string to perform ohmic measurements:", -1 /* HOISTED */);
const _hoisted_3 = {
    key: 0,
    class: "badge bg-danger ms-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_radio = _resolveComponent("b-form-radio");
    const _component_b_form_radio_group = _resolveComponent("b-form-radio-group");
    const _component_b_modal = _resolveComponent("b-modal");
    return (_openBlock(), _createBlock(_component_b_modal, {
        modelValue: _ctx.isVisible,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.isVisible) = $event)),
        title: "Ohmic Measurement",
        onHidden: _ctx.onHidden,
        onOk: _ctx.onOk,
        "ok-title": "Start",
        "cancel-title": "Cancel"
    }, {
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createVNode(_component_b_form_radio_group, {
                    modelValue: _ctx.selectedStringId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedStringId) = $event)),
                    stacked: ""
                }, {
                    default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strings, (string) => {
                            return (_openBlock(), _createBlock(_component_b_form_radio, {
                                key: string.componentId,
                                value: string.componentId,
                                class: "d-flex align-items-center"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(string.componentName) + " ", 1 /* TEXT */),
                                    (!_ctx.isOnfloat(string.componentId))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, "\r\n\t\t\t\t\t\tNot in Float\r\n\t\t\t\t\t"))
                                        : _createCommentVNode("v-if", true)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value"]));
                        }), 128 /* KEYED_FRAGMENT */)),
                        _createTextVNode(),
                        _createVNode(_component_b_form_radio, { value: -1 }, {
                            default: _withCtx(() => [
                                _createTextVNode("All Strings")
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue"])
            ])
        ]),
        _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue", "onHidden", "onOk"]));
}
